var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCastaliaLogo = function SvgCastaliaLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 426.857,
    height: 426.857,
    viewBox: "0 0 112.939 112.939",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.204 -9.676)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeDasharray: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 4,
    strokeOpacity: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 65.673,
    cy: 66.146,
    r: 55.94,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.058
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.528,
    cy: 94.103,
    r: 27.948,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.058
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.528,
    cy: 38.211,
    r: 27.948,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.058
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.058,
    cy: 4.275,
    r: 27.948,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.058,
    transform: "rotate(60)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.058,
    cy: -51.617,
    r: 27.948,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.058,
    transform: "rotate(60)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.53,
    cy: -61.882,
    r: 27.948,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.058,
    transform: "rotate(120)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.53,
    cy: -117.774,
    r: 27.948,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.058,
    transform: "rotate(120)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.673,
    cy: 66.146,
    r: 27.948,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.058
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.731,
    cy: 24.236,
    r: 1.478,
    fill: "currentColor",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 0.752
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.326,
    cy: 24.236,
    r: 1.478,
    fill: "currentColor",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 0.752
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.122,
    cy: 66.158,
    r: 1.478,
    fill: "currentColor",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 0.752
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.326,
    cy: 108.078,
    r: 1.478,
    fill: "currentColor",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 0.752
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.731,
    cy: 108.078,
    r: 1.478,
    fill: "currentColor",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 0.752
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.934,
    cy: 66.157,
    r: 1.478,
    fill: "currentColor",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 0.752
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.73,
    cy: 52.184,
    r: 1.478,
    fill: "currentColor",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 0.752
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.527,
    cy: 38.209,
    r: 1.478,
    fill: "currentColor",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 0.752
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.463,
    cy: 52.183,
    r: 1.478,
    fill: "currentColor",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 0.752
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.476,
    cy: 80.131,
    r: 1.478,
    fill: "currentColor",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 0.752
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.521,
    cy: 94.093,
    r: 1.478,
    fill: "currentColor",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 0.752
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.801,
    cy: 80.25,
    r: 1.478,
    fill: "currentColor",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 0.752
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.673,
    cy: 66.146,
    r: 1.478,
    fill: "currentColor",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 0.752
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCastaliaLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/castalia-logo.343da293ac9c1c9209b556f6da93653d.svg";